import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Broker, ConnectedBroker, Vendor } from '../manage-broker.interface';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ManageBrokerService } from '../manage-broker.service';
import { NgxToastrService } from '@app/_shared';
import { ConfigurationService } from '@app/_shared/providers/configuration/configuration.service';


@Component({
  selector: 'app-non-partner-direct-login',
  templateUrl: './non-partner-direct-login.component.html',
  styleUrls: ['./non-partner-direct-login.component.scss']
})
export class NonPartnerDirectLoginComponent {
  formGroup: FormGroup;
  /** Tracks visibility of sensitive field values (field name -> visible). */
  visibleFields: { [fieldName: string]: boolean } = {};
  multiBrokerDetails: any;

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: {brokerDetails: Broker, broker: ConnectedBroker},
    private dialogRef: MatDialogRef<NonPartnerDirectLoginComponent>,
    private manageBrokerService: ManageBrokerService,
    private snackBar: NgxToastrService,
    private configurationService: ConfigurationService,
  ) {
    this.formGroup = new FormGroup({});
  }
  //brokerDetails is the details from schemas call i.e. available brokers
  ngOnInit(): void {
    this.multiBrokerDetails = this.configurationService.remoteConfigCacheObj.MULTI_BROKER_DETAILS;
    this.manageBrokerService.getBrokerApiKey(this.data.brokerDetails.broker, this.data.broker.broker_id).subscribe((response) => {
      this.formGroup.patchValue(response.data);
    });
    this.data.brokerDetails.login_fields.forEach(field => {
        this.formGroup.addControl(field.name, new FormControl('', [Validators.required]));
    })
  }

  isFieldVisible(fieldName: string): boolean {
    return !!this.visibleFields[fieldName];
  }

  toggleFieldVisibility(fieldName: string): void {
    this.visibleFields[fieldName] = !this.visibleFields[fieldName];
  }

  openHelp(): void {
    const helpLink = this.multiBrokerDetails[this.data.brokerDetails.broker].login_help_link;
    if (helpLink) {
      window.open(helpLink);
    }
  }

  saveBroker(): void {
    if (this.formGroup.valid) {
      this.dialogRef.close(this.formGroup.value);
    }
  }
}
